import React from 'react';
import { Button as AntButton } from 'antd';
import './Button.scss';

interface IProps {
  text?: string;
  type?: 'primary' | 'text' | 'link' | 'ghost' | 'default' | 'dashed';
  className?: string;
  href?: string;
  target?: string;
  icon?: JSX.Element;
  disabled?: boolean;
  onClick?: () => void;
}

export const Button = (props: IProps) => {
  const { type = 'primary', text, className, href, target = '_blank', icon, disabled, onClick } = props;

  return (
    <AntButton disabled={disabled} icon={icon} target={target} href={href} onClick={onClick} type={type} className={`inital ${className}`}>
      {text}
    </AntButton>
  );
};
